import { ENDPOINT } from 'src/constants/api';

import { baseApi } from './base';

const errorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendError: builder.mutation({
      query: (error: ErrorData) => ({
        url: `${ENDPOINT}/error/add`,
        body: {
          namespace: 'DMS', 
          location: window.location.href,
          message: error.id,
          payload: error.id
        },
        method: 'POST',
      })
    }),    
  })
});

export const {
  useSendErrorMutation
} = errorApi;
